/**
 * Chat Header Renderer
 * Template function for rendering chat header
 */

import { html, type TemplateResult } from 'lit';

/**
 * Renders the chat header with controls
 */
export function renderChatHeader(
  showDropdown: boolean,
  onToggleDropdown: () => void,
  onMinimize: () => void,
  onClose: () => void
): TemplateResult {
  return html`
    <div class="chat-header">
      <div class="header-avatar"></div>
      <div class="header-info">
        <h3>MARIANA</h3>
      </div>
      <div class="header-controls">
        <button class="control-button" @click=${onToggleDropdown}></button>
        <div class="dropdown-menu ${showDropdown ? 'dropdown-menu-open' : 'dropdown-menu-closed'}">
          <button class="dropdown-item" @click=${onMinimize}>Minimizar</button>
          <button class="dropdown-item dropdown-item-danger" @click=${onClose}>Terminar chat</button>
        </div>
      </div>
    </div>
    <div class="header-separator"></div>
  `;
}
